import { Injectable } from "@angular/core";
import { Service } from "src/app/core/jsonapi/service";
import { DialPlanAction } from "../_types/dial-plan-action";

@Injectable({
    providedIn: 'root',
})
export class DialPlanActionsService extends Service<DialPlanAction> {
  public override type = 'dialPlanActions';
  public override url = 'Voip/dialPlanActions';
}
